import React from "react";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { addSideBarBackGround } from "../../../reduxToolkit/reducers/layout/themeCustomizerSlice";
import ConfigDB from "../../../config/Theme";
import SvgIcon from "../../../coreComponents/SvgIcon";

const Mode = () => {
  const dispatch = useAppDispatch();
  const darkModeHandler = (data: string) => dispatch(addSideBarBackGround(data));

  return (
    <li onClick={() => darkModeHandler(ConfigDB.color.mixBackgroundLayout !== "light" ? "light" : "dark-only")}>
      <div className={`mode ${ConfigDB.color.mixBackgroundLayout !== "light" ? "active" : ""}`}>
        <SvgIcon className="for-dark" iconId="moon" />
        <SvgIcon className="for-light" iconId="Sun" />
      </div>
    </li>
  );
};
export default Mode;
